/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dice_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does dNN mean?`)
};

const es_dice_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué significa dNN?`)
};

const de_dice_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was bedeutet dNN?`)
};

const nl_dice_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat betekent dNN?`)
};

const fr_dice_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que signifie dNN ?`)
};

const it_dice_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa significa dNN?`)
};

const pt_br2_dice_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que significa dNN?`)
};

const pt_dice_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que significa dNN?`)
};

const ja_dice_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dNNとはどういう意味ですか?`)
};

const zh_dice_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“dNN”是什么意思？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dice_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dice_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dice_faq_q3", locale)
	if (locale === "en") return en_dice_faq_q3(inputs)
	if (locale === "es") return es_dice_faq_q3(inputs)
	if (locale === "de") return de_dice_faq_q3(inputs)
	if (locale === "nl") return nl_dice_faq_q3(inputs)
	if (locale === "fr") return fr_dice_faq_q3(inputs)
	if (locale === "it") return it_dice_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_dice_faq_q3(inputs)
	if (locale === "pt") return pt_dice_faq_q3(inputs)
	if (locale === "ja") return ja_dice_faq_q3(inputs)
	return zh_dice_faq_q3(inputs)
};